let activeChatUserId = null;
let pendingChatUserId = null;

export const setActiveChatUserId = (id) => { activeChatUserId = id ? String(id) : null; };
export const getActiveChatUserId = () => activeChatUserId;

// Used when the user clicks a notification
export const requestOpenChat = (id) => {
  pendingChatUserId = String(id);
  window.dispatchEvent(new CustomEvent('chat:open', { detail: String(id) }));
};
export const consumePendingChat = () => {
  const id = pendingChatUserId;
  pendingChatUserId = null;
  return id;
};